import React, { useMemo, useCallback } from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { injectIntl, defineMessages } from 'react-intl';
import SettingDropdown from './SettingDropdown';
import { getDevicesByKind } from 'utils/deviceUtils';
import DropdownLabel from 'components/Dropdown/DropdownLabel';

const messages = defineMessages({
  inputCamera: { id: 'components.avSettings.inputLabel.Camera', defaultMessage: 'Camera' }
});

export interface Props {
  intl?: { formatMessage: Function };
  wide?: boolean;
  handleConfigChange: Function;
}

const CameraDropdown = (props: Props) => {
  const { intl, handleConfigChange, wide } = props;
  const devices = hooks.useDevices();
  const { videoDevice } = hooks.useMedia();
  const videoInputDevices = useMemo(() => getDevicesByKind(devices, 'videoinput'), [devices]);

  const getDeviceValue = useCallback(() => {
    const selectedDevice =
      videoInputDevices.find((device) => device.value === videoDevice?.deviceId) || videoInputDevices?.[0];
    return selectedDevice?.value;
  }, [videoInputDevices, videoDevice]);

  useCallback(() => {
    handleConfigChange('camera', getDeviceValue());
  }, [handleConfigChange, getDeviceValue]);

  const onSelectVideoSource = async (deviceId) => {
    await handleConfigChange('camera', deviceId);
  };

  return (
    <section>
      <DropdownLabel
        error={!(videoInputDevices?.length > 0)}
        label={intl?.formatMessage(messages.inputCamera)}
        dataTestId={'cameraSelectionHeader'}
      />
      <SettingDropdown
        handleChange={onSelectVideoSource}
        items={videoInputDevices}
        label={intl?.formatMessage(messages.inputCamera)}
        testIdPrefix="camera"
        value={getDeviceValue()}
        wide={wide}
      />
    </section>
  );
};

export default injectIntl(CameraDropdown);
